import React, { useEffect, useRef, useState } from 'react';
// import shredder from '../assets/Weightloss-img6.jpg';
// import shredder from '../assets/testimonial3.jpeg';
import shredder from '../assets/shredder1.jpeg';
// import shredder from '../assets/shredder2.jpeg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import observer from '../utils/observer';

const Shredder = () => {
  const [spin, setSpin] = useState(true);
  const containerRefValue = useRef(null);
  const [isMoreText, setIsMoreText] = useState(false);

  setTimeout(() => {
    setSpin(false);
  }, 2000);

  useEffect(() => {
    observer(containerRefValue, 'section-hidden');
  }, [containerRefValue]);

  const showOrHideText = () => {
    setIsMoreText(!isMoreText);
  };

  return (
    <div className="shredder-container section-hidden" ref={containerRefValue}>
      <div className="shredder-text-container">
        <div className="shredder-text-header">
          Meet the Shredder of the month
        </div>
        <div
          className="shredder-text"
          style={isMoreText ? { height: '100%', overflow: 'visible' } : {}}
        >
          <div>
            Every month, we shine our spotlight on the shredder that made a
            remarkable transformation since joining Fitness Space. This month,
            our lenses is on Abimbola from Lagos State.
          </div>
          <div>
            In January 2023, Abimbola embarked on a transformative journey with
            Fitness Space, and the results have been nothing short of
            incredible. From a size 10-12, she achieved a confident size 8,
            maintaining a steady weight between 58kg and 59kg. In her words,
            "the journey has been more than just physical; Fitness Space has
            given me back not just my body but my life and soul".
          </div>
          <div>
            Her success extends beyond external changes. Fitness Space has
            become an awesome experience, shaping her identity through tailored
            workouts, personalized intermittent fasting, personalized
            intermittent fasting, personalized portion control guide and a
            commitment to a healthier lifestyle.
          </div>
          <div>
            Grateful for the ongoing transformation, she affirms that Fitness
            Space is not just a program but family that has become an integral
            part of her life. She will always be grateful and proud to be part
            of the Fitness Space community.
          </div>
        </div>
        <div
          className="read-more-button shredder-read-more"
          onClick={showOrHideText}
        >
          <div
            className="read-more-button-text"
          >
            Read {isMoreText ? 'Less' : 'More'}
          </div>
          <FontAwesomeIcon icon={faArrowRight} spin={spin} />
        </div>
      </div>
      <div className="shredder-image-container">
        <img src={shredder} alt="shredder" className="shredder-image" />
      </div>
    </div>
  );
};

export default Shredder;
